export enum EntryTypes {
  RegisterNewAccount = 1,
  ResetPassword = 2,
}
